import React from 'react';
import { Testimonial } from '../types';
import { Star, MessageSquareQuote } from 'lucide-react';

export const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: "Markus W.",
      role: "CEO",
      company: "TechStart Berlin",
      quote: "Endlich eine Agentur, die nicht nur 'hübsch' macht, sondern Zahlen liefert. Unsere Lead-Kosten sind um 40% gesunken.",
    },
    {
      id: 2,
      name: "Julia S.",
      role: "Marketing Head",
      company: "Fashion Direct",
      quote: "Die Content-Produktion ist unfassbar schnell. Was zackig in einer Woche liefert, haben andere in einem Monat nicht geschafft.",
    },
    {
      id: 3,
      name: "Dennis K.",
      role: "Inhaber",
      company: "Gastro Group",
      quote: "Der neue Webshop konvertiert wie Hölle. Investment war nach 2 Monaten wieder drin. 5 Sterne!",
    }
  ];

  return (
    <section className="py-24 bg-[#fafafa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 relative">
           <MessageSquareQuote className="w-24 h-24 text-gray-100 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -z-10" />
           <h2 className="text-4xl md:text-6xl font-black text-brand-dark uppercase tracking-tighter mb-4">
             Partnerstimmen
           </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((t) => (
            <div key={t.id} className="bg-white p-8 rounded-3xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.05)] border border-gray-100 hover:-translate-y-2 transition-all duration-300 flex flex-col h-full">
              <div className="flex gap-1 mb-6">
                 {[1,2,3,4,5].map(s => (
                   <Star key={s} size={18} className="fill-brand-orange text-brand-orange" />
                 ))}
              </div>
              
              <p className="text-brand-dark font-bold text-lg mb-8 leading-relaxed flex-grow italic">"{t.quote}"</p>
              
              <div className="flex items-center gap-4 pt-6 border-t border-gray-50">
                <div className="w-10 h-10 rounded-full bg-brand-dark text-white flex items-center justify-center font-bold">
                    {t.name.charAt(0)}
                </div>
                <div>
                    <h4 className="font-black text-brand-dark uppercase text-sm">{t.name}</h4>
                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider">{t.role} @ <span className="text-brand-orange">{t.company}</span></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};